import { Box, Button, Card, FormControl, Grid, InputAdornment, InputLabel, List, OutlinedInput, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import PersonIcon from '@mui/icons-material/Person';
import UserThreeDots from "../../components/Shared/UserThreeDots";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { useEffect, useState } from "react";
import { UserServiceInternal } from "../../services/user.service";
import { ProviderServiceInternal } from "../../services/provider.service";
import FullPageLoader from "../../components/Shared/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProviderManagent = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);

    const fetchDataFromApi = async () => {
        try {
            setIsLoading(true);
            const response = await UserServiceInternal.getuserlist();
            if (response?.data.isSuccess) {
                setData(response.data.data);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data from API:', error);
        }
    }

    const navigate = useNavigate();
    const handleClick = (e: any) => {
        navigate("/new-provider");
    };

    const handleEditClick = (userId: number) => {
        setSelectedUserId(userId);
        navigate(`/edit-provider?id=${userId}`);
    };

    const handleDeleteClick = async (userId: number) => {

        const response = await ProviderServiceInternal.deleteprovider(userId);
        if (response?.data.isSuccess) {
            fetchDataFromApi();
            toast.success("Deleted Successfully")
            // window.location.reload();
        }
    };

    useEffect(() => {
        fetchDataFromApi();
    }, []);

    return (
        <Layout>
            {isLoading && <FullPageLoader />}
            <Typography
                sx={{
                    maxWidth: "100%",
                    minHeight: "70%",
                    maxHeight: "100%",
                    padding: 3,
                    margin: 2,
                    textAlign: "center",
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }}>
                    <FormControl sx={{ m: 1, width: '50%' }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type="text"
                            onChange={(e: any) => {
                                //InputHandler(e);
                            }}
                            onKeyDown={(e: any) => {
                                //onKeyDownHandler(e);
                            }}
                            placeholder="Search here"
                            endAdornment={
                                <InputAdornment position="end" sx={{ cursor: "pointer " }}>
                                    <SearchSharpIcon
                                        onClick={() => {
                                            //  setSearchQueryString(searchText);
                                        }}
                                    />
                                </InputAdornment>
                            }
                            label="Search"
                        />
                    </FormControl>
                    <Button onClick={handleClick} sx={{ height: "50px" }} variant="contained"> + New Provider</Button>
                </Box>
                <div>
                    <List sx={{ margin: "auto", textAlign: "center", width: "95%", marginTop: "5px" }}>
                        <Grid container sx={{ gridAutoRows: "1fr" }} rowSpacing={2} spacing={2} className="gridManagementScreen">
                            {
                                data && data.length > 0 ?
                                    (
                                        data.map((list: any) => {
                                            if (list.userrole === 'ITP-Provider') {
                                                return (
                                                    <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                                                        <Card elevation={3} sx={{ p: 2, height: "95%" }} className='PendingRequestItem'>
                                                            <div>
                                                                <Box sx={{ display: "flex", mb: 3, justifyContent: "space-between" }}>
                                                                    <div>
                                                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "start" }}>
                                                                            <div>
                                                                                {
                                                                                    <PersonIcon sx={{ height: "80px", width: "80px", border: "2px solid", borderRadius: "50px" }} />
                                                                                }
                                                                            </div>
                                                                            <div className='userInformation'>
                                                                                <div className='userName'>{list.first_name}  {list.last_name}</div>
                                                                                <div className='userEmail'><b>{list.email}</b></div>
                                                                            </div>
                                                                        </Box>
                                                                    </div>
                                                                    <div>
                                                                        <UserThreeDots onEditClick={handleEditClick} onDeleteClick={handleDeleteClick} userId={list.id} />
                                                                    </div>
                                                                </Box>
                                                            </div>
                                                        </Card>
                                                    </Grid>
                                                )
                                            }
                                        })
                                    ) :
                                    (
                                      <Grid container sx={{justifyContent:"center", mt:"40px"}}>
                                        {!isLoading && <label>User List not Found</label>}
                                      </Grid>
                                    )
                            }
                        </Grid>
                    </List>
                </div>
            </Typography>
        </Layout>
    )
}
export default ProviderManagent;